export function createCaptionObj(caption: string) {
  return {
    translations: [
      { localeId: 1, value: caption },
      { localeId: 2, value: caption },
      { localeId: 3, value: caption },
    ],
  };
}
